import {Component,EventEmitter,Input,OnInit,Output} from '@angular/core';

@Component({
  selector: 'app-fee-list',
  templateUrl: './fee-list.component.html',
  styleUrls: ['./fee-list.component.scss'],
    standalone: false
})

export class FeeListComponent implements OnInit {
  @Input() title: string = '';
  @Input() fees: any[] = [];
  @Input() moduleType!: number;
  @Input() readonly: boolean = false;
  @Input() reasonRequired: boolean = false;
  @Input() FeesEditRight: boolean = false;
  @Input() manualFeesAndCharges: any[] = [];
  @Input() eNumElementTypes: any;
  @Input() eNumActionTypes: any;
  @Input() disableOption?: (feesAndChargesId: number) => boolean;
  @Input() disableStopDates!: (item: any) => boolean;
  @Input() isReasonAdded!: (item: any) => boolean;
  @Input() onLoadEffectiveDate!: (args: any) => void;
  @Input() onLoadStopDate!: (args: any,item: any) => void;
  @Output() feesSelectionChanged = new EventEmitter<any>();
  @Output() feeChanged = new EventEmitter<any>();
  @Output() feeChargeChanged = new EventEmitter<any>();
  @Output() effectiveDateChanged = new EventEmitter<any>();
  @Output() stopDateChanged = new EventEmitter<any>();
  @Output() notesChanged = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

  checkFeesCharges(event: any,feesAndChargesId: number,item: any): void {
    this.feesSelectionChanged.emit({event,feesAndChargesId,item});
  }

feeschargesChanged(
  event: any,
  item: any
): void {

  this.feeChargeChanged.emit({
    event,
    item
  });

}

  feesChanged(event: any,feesAndChargesId: number,item: any): void {
    this.feeChanged.emit({event,feesAndChargesId,item});
  }

  effectiveDateChange(event: any,feesAndChargesId: number,item: any): void {
    this.effectiveDateChanged.emit({event,feesAndChargesId,item});
  }

  StopDateChange(event: any,feesAndChargesId: number,item: any): void {
    this.stopDateChanged.emit({event,feesAndChargesId,item});
  }

  onNotesEntered(event: any,feesAndChargesId: number,item: any): void {
    this.notesChanged.emit({event,feesAndChargesId,item});
  }

onStopDateInput(args: InputEvent, item: any) {

  const text = (args.target as HTMLInputElement)?.value?.trim() ?? '';

  item.stopDateInputText = text;

  if (!text) {
    item.showStopDateError = false;
    return;
  }

  item.showStopDateError = true;
}

onStopDateCleared(item: any) {
    item.stopDateInputText = '';
    item.StopDate = null;
    item.showStopDateError = false;
}
onStopDateClose(item: any) {

  if (item.StopDate) {
    item.stopDateInputText = '';
    item.showStopDateError = false;
  }
}
trackByFeeRow(index: number, item: any) {
  return item._rowId || index;
}
}
